import React, { useState, useEffect } from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import './styles.scss';

const ResizableTitle = (props) => {
  const { onResize, onResizeStop, width, ...restProps } = props;
  const [localWidth, setLocalWidth] = useState(width);

 // Keep local in sync if parent width changes (e.g., from typing in the popover)
  useEffect(() => {
    setLocalWidth(width);
  }, [width]);

  if (typeof width !== 'number') {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={localWidth}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => e.stopPropagation()} 
        />
      }
      onResizeStart={() => {
        document.body.classList.add('is-resizing-column');
      }}
      onResize={(_, { size }) => setLocalWidth(size.width)}
      onResizeStop={(_, { size }) => {
        document.body.classList.remove('is-resizing-column');
        onResize?.(_, { size });
      }}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} style={{ ...restProps.style, width: localWidth }} />
    </Resizable>
  );
};

export default ResizableTitle;